import { render, staticRenderFns } from "./ShipmentsOverviewMobile.vue?vue&type=template&id=bfd086da&scoped=true&"
import script from "./ShipmentsOverviewMobile.vue?vue&type=script&lang=js&"
export * from "./ShipmentsOverviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsOverviewMobile.vue?vue&type=style&index=0&id=bfd086da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd086da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd086da')) {
      api.createRecord('bfd086da', component.options)
    } else {
      api.reload('bfd086da', component.options)
    }
    module.hot.accept("./ShipmentsOverviewMobile.vue?vue&type=template&id=bfd086da&scoped=true&", function () {
      api.rerender('bfd086da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/Shipments/ShipmentsOverviewMobile.vue"
export default component.exports